import React from 'react';
import { Button } from 'reactstrap';

const StatusBadges = ({ statusWorkflow, declineReason }) => {
    if (statusWorkflow === 'coming-soon') {
        return (
            <Button color="light" outline disabled>
                <span className="fas fa-hourglass-half me-2" />
                Coming Soon
            </Button>
        );
    }

    if (statusWorkflow === 'request-declined') {
        return (
            <Button color="danger" disabled>
                <span className="fas fa-times-circle me-2" />
                Request declined
            </Button>
        );
    }

    if (['movie-delivery-pending', 'key-delivery-pending'].includes(statusWorkflow)) {
        return (
            <Button color="light" outline disabled>
                <span className="fas fa-spinner fa-spin me-2" />
                Delivery pending
            </Button>
        );
    }

    if (statusWorkflow === 'ready-to-play') {
        return (
            <Button color="light" outline disabled>
                <span className="fas fa-spinner fa-spin me-2" />
                Preparing for playback
            </Button>
        );
    }

    return null;
};

export default StatusBadges;
